import { render } from "./sparepart-view.vue?vue&type=template&id=7e82a914&ts=true"
import script from "./sparepart-view.vue?vue&type=script&lang=ts"
export * from "./sparepart-view.vue?vue&type=script&lang=ts"

import "./sparepart-view.vue?vue&type=style&index=0&id=7e82a914&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__